//// Vendors ////
import AOS from 'aos';

//// SITE functions ////
import { sitePreloader } from './components/_site-preloader';

import { navigation } from './components/_navigation';

import { scroll } from './components/_scroll';

import { splide } from './components/_splide';

import { team } from './components/_team';

// DOM ready first
document.addEventListener(
    'DOMContentLoaded',
    function () {
        // // splide
        splide();

        // naviagtion
        navigation();

        // scroll show-hide
        scroll();

        // team
        team();

        // AOS
        AOS.init({
            duration: 800,
            offset: 40
        });
    },
    false
);

// window.load next
window.addEventListener('load', sitePreloader);
